// Fetch list

export const FETCH = 'trailerCurrentPositions.FETCH'
export const FETCH_STARTED = 'trailerCurrentPositions.FETCH_STARTED'
export const FETCH_FULFILLED = 'trailerCurrentPositions.FETCH_FULFILLED'
export const FETCH_REJECTED = 'trailerCurrentPositions.FETCH_REJECTED'
export const FETCH_CANCELLED = 'trailerCurrentPositions.FETCH_CANCELLED'
